import VSelect from '../components/VSelect.vue'

export default {
    install: (app, options) => {
        // Register our custom VSelect component as v-select
        app.component('v-select', VSelect);
    }
}
